import { Header, AuthorizedPartners as AuthorizedPartnersComponent } from 'components';

export const AuthorizedPartners = () => {
  return (
    <>
      <Header />
      <AuthorizedPartnersComponent />
    </>
  );
};

